import { ComponentNames } from "src/app/helper/componentNames";
import { BaseComponent } from "../BaseComponent";

export class FloorComponent extends BaseComponent {
    constructor() {
        super();
        this.componentType = ComponentNames.floorComponent;
    }

    floorImageBase64Data: string;
    isFloorImageVisible: boolean;
}